export default __webpack_public_path__ + "static/media/details_icon_disabled.33e9693a.svg";